import WebviewClick  from './webview-click'
import ImageOverlayClick from './image-overlay-click'
import AudioFinish from './audio-finish'
import VideoFinish from './video-finish'
import Gps from './gps'
import Timer from './timer'
import WebviewScript from './webview-script'
import NotificationClick from './notification-click'
import Qrcode from './qrcode'
import FlagMatch from './flag-match'
import Beacon from './beacon'
import Wifi from './wifi'
import FakeCallDeclined from './fake-call-declined'
import PushEvent from './push-event'
import StepCountExceed from './step-count-exceed'

ICON_BY_TYPE =
  audioFinish: "fa-volume-up"
  beacon: "fa-broadcast-tower"
  fakeCallDeclined: "fa-phone-slash"
  flagMatch: "fa-flag"
  gps: "fa-map-marker-alt"
  imageOverlayClick: "fa-layer-group"
  notificationClick: "fa-bell"
  pushEvent: "fa-server"
  qrcode: "fa-qrcode"
  stepCountExceed: "fa-shoe-prints"
  timer: "fa-clock"
  videoFinish: "fa-video"
  webviewClick: "fa-mouse-pointer"
  webviewScript: "fa-code"
  wifi: "fa-wifi"

conditions = {}

for conditionTypeClass in [
  WebviewClick, ImageOverlayClick, AudioFinish, VideoFinish, Gps, Timer, WebviewScript,
  NotificationClick, Qrcode, FlagMatch, Beacon, Wifi, FakeCallDeclined, PushEvent, StepCountExceed
]
  className = conditionTypeClass.name
  typeName = className.charAt(0).toLowerCase() + className.slice(1)

  conditionTypeClass.icon ?= ICON_BY_TYPE[typeName] || "fa-bolt"
  conditions[typeName] = conditionTypeClass

export default conditions
